import { FC } from 'react';

import { Typography, Card, Row } from 'antd';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import Table from '@/components/RTable';

import StyledAncillaryTable from './styles';

type AncillaryRow = {
  id: number;
  dateTime: string;
  pfcbno: number;
  sfcbno: number;
};

const buildAncillaryData = (): AncillaryRow[] => {
  const fmt = 'DD.MM.YYYY HH:mm';
  const start = dayjs().startOf('day');
  const hours = Array.from({ length: 24 }, (_, h) => h);

  const pfcs = [
    1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 6, 6, 6, 7, 7, 7,
  ];
  const sfcs = [
    1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  ];

  return hours.map((h, i) => ({
    id: i + 1,
    dateTime: start.add(h, 'hour').format(fmt),
    pfcbno: pfcs[i],
    sfcbno: sfcs[i],
  }));
};

const AncillaryServices: FC = () => {
  const { t } = useTranslation();

  const ancillaryColumns = [
    {
      title: t('storageSystem.form.ancillaryServices.dateTime'),
      dataIndex: 'dateTime',
      key: 'dateTime',
      width: '30%',
    },
    {
      title: t('storageSystem.form.ancillaryServices.pfcbno'),
      dataIndex: 'pfcbno',
      key: 'pfcbno',
      align: 'right' as const,
      width: '35%',
    },
    {
      title: t('storageSystem.form.ancillaryServices.sfcbno'),
      dataIndex: 'sfcbno',
      key: 'sfcbno',
      align: 'right' as const,
      width: '35%',
    },
  ];

  return (
    <StyledAncillaryTable>
      <Card
        title={
          <Typography.Title level={4}>
            {t('storageSystem.form.ancillaryServices.title')}
          </Typography.Title>
        }
        className="p-24"
      >
        <Row className="my-12">
          <Typography.Text type="secondary" style={{ whiteSpace: 'pre-line' }}>
            {t('storageSystem.form.ancillaryServices.description')}
          </Typography.Text>
        </Row>
        <Table
          rowKey="id"
          columns={ancillaryColumns}
          dataSource={buildAncillaryData()}
          pagination={false}
          bordered
        />
      </Card>
    </StyledAncillaryTable>
  );
};

export default AncillaryServices;
